<script>
    import ProfileService from "../services/api/ProfileService";

    export default {
        data(){
            return {
                profileData: {}
            }
        },
        name: "ProfileDataProvider",
        computed: {
            storeProfileData(){
                return this.$store.getters.profileData;
            },
            isSeller() {
                return (this.storeProfileData.isSeller === undefined) ? false : this.storeProfileData.isSeller;
            },
        },
        methods: {
            getProfileData(){
                ProfileService.setLocale(this.$store.state.language.appLanguage);

                return ProfileService.generalData();
            },
            isProfileEmpty() {
                return !Object.keys(this.$store.state.account.profileData).length;
            },
            setProfileData(force) {
                const data = this.$store.state.account.profileData;

                if(Object.keys(data).length && !force) return false;

                this.getProfileData()
                    .then(res => {
                        this.$store.commit('updateProfileData', res.profileData);
                        this.loading = false;
                    })
                    .catch(err => {});
            },
            setStateProfile(profileData) {
                this.$store.commit('updateProfileData', profileData);
            },
            showSellerRegDialog(){
                this.$store.commit('sellerRegDialogShow');
            },
        }
    }
</script>
